import { joinUrlParams, urlResolve } from "../url";
import { getSsoLoginParams } from "../../api";
import { EXTENSIONS_WEB_URL } from "../../constants";
import BasicRecord from "../BasicRecord";
import SSOLoginParams, { SAMLParams } from "../../api/model/users/SSOLoginParams";

const loginResponseHandlers: BasicRecord<typeof redirectToSamlUrl> = {
    redirect: redirectToSamlUrl,
    post: postToSamlUrl
};

function handleLoginGoogle(email: string, {
    isSignup = false,
    useExtensionsWindow = false
}) {
    const action = isSignup ? "signup" : "login";
    const url = urlResolve("authGoogle", { query: { action, loginHint: email } });
    if (useExtensionsWindow) {
        window.parent.postMessage({ googleLoginURL: url }, EXTENSIONS_WEB_URL);
        return;
    }
    location.assign(url);
}

function redirectToSamlUrl(url: string, message: BasicRecord, { isSignup }: {
    isSignup: boolean;
}) {
    const urlWithParams = new URL(url);
    urlWithParams.search = joinUrlParams({
        ...message,
        RelayState: btoa(JSON.stringify({
            isSignup
        }))
    });
    window.location.assign(urlWithParams.toString());
}

function postToSamlUrl(url: string, message: BasicRecord, { isSignup }: {
    isSignup: boolean;
}) {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;

    Object.keys(message).forEach(key => {
        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = key;
        hiddenField.value = message[key];

        form.appendChild(hiddenField);
    });

    if (isSignup) {
        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = "RelayState";
        hiddenField.value = btoa(JSON.stringify({ isSignup }));
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
}

export function handleSSOLoginSignup(loginParams: SSOLoginParams, email: string, {
    useExtensionsWindow = false,
    isSignup = false
} = {}) {
    const { provider: { type: providerType }, params: { type, url } } = loginParams;
    const handler = loginResponseHandlers[type];
    if (!handler) {
        throw new Error(`${type} is not a valid SAML type`);
    }

    if (providerType === "google") {
        handleLoginGoogle(email, {
            isSignup,
            useExtensionsWindow
        });
        return;
    }

    const { message } = loginParams.params as SAMLParams;

    if (useExtensionsWindow) {
        window.parent.postMessage({
            saml: {
                type,
                url,
                message
            }
        }, EXTENSIONS_WEB_URL);
        return;
    }

    handler(url, message, {
        isSignup
    });
}

export function performLogin(email: string, {
    useExtensionsWindow = false,
    isSignup = false
} = {}) {
    return getSsoLoginParams(email).then(loginParams => {
        handleSSOLoginSignup(loginParams, email, {
            useExtensionsWindow,
            isSignup
        });
    });
}
